const { Box, Typography } = require("@mui/material");

export const VideoTitle = ({
  title = <>Selecionar vídeo(s) para </>,
  name,
}) => (
  <Box
    sx={{
      display: "grid",
      gap: "10px",
      alignItems: "center",
      gridTemplateColumns: "min-content auto",
    }}
  >
    <svg
      width="33"
      height="33"
      viewBox="0 0 53 53"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="4.00391"
        y="4.4082"
        width="44"
        height="44"
        rx="11"
        fill="#1361A4"
        fillOpacity="0.15"
      />
      <g clipPath="url(#clip0_1413_7316)">
        <path
          d="M32.6289 19.4707C33.9277 19.4707 35.0039 20.5469 35.0039 21.8457V33.7207C35.0039 35.0566 33.9277 36.0957 32.6289 36.0957H18.3789C17.043 36.0957 16.0039 35.0566 16.0039 33.7207V21.8457C16.0039 20.5469 17.043 19.4707 18.3789 19.4707H32.6289ZM20.1602 34.3145V31.0488H17.7852V33.7207C17.7852 34.0547 18.0449 34.3145 18.3789 34.3145H20.1602ZM20.1602 29.2676V26.2988H17.7852V29.2676H20.1602ZM20.1602 24.5176V21.252H18.3789C18.0449 21.252 17.7852 21.5488 17.7852 21.8457V24.5176H20.1602ZM29.0664 34.3145V28.6738H21.9414V34.3145H29.0664ZM29.0664 26.8926V21.252H21.9414V26.8926H29.0664ZM33.2227 33.7207V31.0488H30.8477V34.3145H32.6289C32.9258 34.3145 33.2227 34.0547 33.2227 33.7207ZM33.2227 29.2676V26.2988H30.8477V29.2676H33.2227ZM33.2227 24.5176V21.8457C33.2227 21.5488 32.9258 21.252 32.6289 21.252H30.8477V24.5176H33.2227Z"
          fill="#1361A4"
        />
      </g>
      <rect
        x="4.00391"
        y="4.4082"
        width="44"
        height="44"
        rx="11"
        stroke="#1361A4"
        strokeOpacity="0.08"
        strokeWidth="8"
      />
      <defs>
        <clipPath id="clip0_1413_7316">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(16.0039 16.4082)"
          />
        </clipPath>
      </defs>
    </svg>
    <Typography>
      {title}
      <span style={{ fontWeight: "bold" }}>{name}</span>
    </Typography>
  </Box>
);

export const SerieTitle = ({
  name,
  title = <> Selecionar série(s) para </>,
}) => (
  <Box
    sx={{
      display: "grid",
      gap: "10px",
      alignItems: "center",
      gridTemplateColumns: "min-content auto",
    }}
  >
    <svg
      width="33"
      height="33"
      viewBox="0 0 53 52"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="4.5"
        y="3.99609"
        width="44"
        height="44"
        rx="11"
        fill="#1361A4"
        fillOpacity="0.15"
      />
      <rect
        x="4.5"
        y="3.99609"
        width="44"
        height="44"
        rx="11"
        stroke="#1361A4"
        strokeOpacity="0.08"
        strokeWidth="8"
      />
      <g clipPath="url(#clip0_1143_75189)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M24.9293 18.1506C29.5843 18.1506 33.3586 21.974 33.3586 26.6918C33.3586 28.6644 32.6976 30.4816 31.5893 31.9278C31.9674 32.0955 32.3315 32.3527 32.7026 32.6149C33.6083 33.2552 34.5772 33.9391 36.1901 32.3374L36.8681 33.0356C34.6816 35.2085 33.3736 34.2847 32.151 33.4208C31.7137 33.1119 31.2904 32.8131 30.815 32.807C29.2964 34.3081 27.2202 35.2329 24.9313 35.2329C20.2733 35.2319 16.5 31.4085 16.5 26.6918C16.5 21.975 20.2733 18.1506 24.9293 18.1506ZM24.9293 25.5454C25.5542 25.5454 26.0597 26.0586 26.0597 26.6908C26.0597 27.3229 25.5532 27.8361 24.9293 27.8361C24.3054 27.8361 23.7989 27.3229 23.7989 26.6908C23.7989 26.0586 24.3054 25.5454 24.9293 25.5454ZM18.5301 22.9477C19.0878 21.9689 20.3225 21.6336 21.2884 22.1986C22.2543 22.7637 22.5853 24.0148 22.0276 24.9935C21.4699 25.9722 20.2352 26.3076 19.2693 25.7425C18.3034 25.1775 17.9724 23.9264 18.5301 22.9477ZM18.5301 30.4349C17.9724 29.4562 18.3034 28.2051 19.2693 27.64C20.2352 27.0749 21.4699 27.4103 22.0276 28.389C22.5853 29.3677 22.2543 30.6188 21.2884 31.1839C20.3225 31.749 19.0878 31.4136 18.5301 30.4349ZM24.9293 34.178C23.8139 34.178 22.9102 33.2623 22.9102 32.1321C22.9102 31.002 23.8139 30.0863 24.9293 30.0863C26.0446 30.0863 26.9484 31.002 26.9484 32.1321C26.9484 33.2623 26.0446 34.178 24.9293 34.178ZM31.3285 30.4349C30.7708 31.4136 29.5361 31.749 28.5702 31.1839C27.6043 30.6188 27.2733 29.3677 27.831 28.389C28.3887 27.4103 29.6234 27.0749 30.5893 27.64C31.5552 28.2051 31.8862 29.4562 31.3285 30.4349ZM31.3285 22.9477C31.8862 23.9264 31.5552 25.1775 30.5893 25.7425C29.6234 26.3076 28.3887 25.9722 27.831 24.9935C27.2733 24.0148 27.6043 22.7637 28.5702 22.1986C29.5361 21.6336 30.7708 21.9689 31.3285 22.9477ZM24.9293 19.2046C26.0446 19.2046 26.9484 20.1203 26.9484 21.2504C26.9484 22.3806 26.0446 23.2963 24.9293 23.2963C23.8139 23.2963 22.9102 22.3806 22.9102 21.2504C22.9102 20.1203 23.8139 19.2046 24.9293 19.2046Z"
          fill="#1361A4"
        />
      </g>
      <defs>
        <clipPath id="clip0_1143_75189">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(16.5 15.9961)"
          />
        </clipPath>
      </defs>
    </svg>

    <Typography>
      {title}
      <span style={{ fontWeight: "bold" }}>{name}</span>
    </Typography>
  </Box>
);

export const CollectionTitle = ({
  name,
  title = <> Selecionar coleção(ões) para </>,
}) => <SerieTitle name={name} title={title} />;
